import admin from '@/utils/http'

export default {
  actions: {
    // 订单
    list(query) {
      return admin.get('/order/list', { query })
    },
    create(data) {
      return admin.post('/order/create', data)
    },
    detail(orderid) {
      return admin.get('/order/detail/' + orderid)
    },
    update(data) {
      return admin.put('/order/update/' + data.orderid, data)
    },
    cancel(orderid) {
      return admin.put('/order/cancel/' + orderid)
    },
    deal(orderid, data) {
      return admin.put('/order/deal/' + orderid, data)
    },
    batchNoOrder(batchID) {
      return admin.get('/order/list', {
        query: {
          batchID: batchID,
          limit: 100000,
        }
      })
    }
  }
}